export default {
  // ip: 'http://localhost:9010'
  // ip: 'http://192.168.0.99:9010'
  // ip: 'http://192.168.1.78:9010'
  // ip: 'http://101.91.121.212:9010'
  ip: 'https://wb.jbd999.com/back'
}
